<div id="labs">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class=" inner-card">
                    <h4 class="card-title ">Computer Lab</h4>
                    <div class="card-body text-justify">
                        <p class="inner-lead">Computer science is a vast and diverse field. Programming is way more than just code: programmers must design, create, solve problems, and think outside the box. 
                        </p>
                        <p class="inner-lead"><i>"Everybody should learn to program a computer, because it teaches you how to think.” - Steve Jobs, former CEO and creator of Apple.</i></p>
                        <p class="inner-lead"><i>“Computer science empowers students to create the world of tomorrow.” - Satya Nadella, CEO of Microsoft
                        </i></p>
                        <p class="inner-lead"><i>“Students who study computer science unlock a world of opportunities for themselves.” - Dr. John Deasy, Former Superintendent, Los Angeles Unified School District
                        </i></p>
                        <div class="row">
                          <div class="col-6 text-center mb-4">
                            <a href="/assets/img/labs/computer/1.jpg" data-lightbox="Computer Lab"><img src="/assets/img/labs/computer/1.jpg" alt="Computer Lab" class="img-fluid rounded"></a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>